<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.81836 0C6.21994 9.6219e-05 6.5459 0.325937 6.5459 0.727539V5.09082H10.9092C11.3107 5.09096 11.6367 5.41679 11.6367 5.81836C11.6366 6.21985 11.3107 6.54575 10.9092 6.5459H6.5459V10.9092C6.54575 11.3107 6.21985 11.6366 5.81836 11.6367C5.41679 11.6367 5.09096 11.3107 5.09082 10.9092V6.5459H0.727539C0.325937 6.5459 9.6219e-05 6.21994 0 5.81836C0 5.4167 0.325877 5.09082 0.727539 5.09082H5.09082V0.727539C5.09082 0.325877 5.4167 0 5.81836 0Z"
      fill="currentColor"
    />
  </svg>
</template>
